export default __webpack_public_path__ + "static/media/zueggL.38b30eb5.jpg";